import React from "react";

import opacity from "hex-color-opacity";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import TooltipBasic from "@src/sharedComponents/Tooltip/TooltipBasic";
import Text from "@src/sharedComponents/Typography/Text";

import graphConfig from "./graphConfig";

import styles from "./Legend.module.css";

const FinancialPlansProjectionGraphLegend: React.FC = () => {
  const {
    color: { $chartSegmentOne },
  } = useTheme();

  const areaFillColor = opacity(
    $chartSegmentOne,
    graphConfig.areaFillColorOpacity
  );

  return (
    <div className={styles.legend}>
      <div
        className={styles.marker}
        style={{ backgroundColor: $chartSegmentOne }}
      />

      <Text variant={"body"} color={"text"}>
        Median
      </Text>

      <TooltipBasic
        className={styles.tooltip}
        type={"secondary"}
        text={
          "The Median Case represents a 50% probability of achieving that net worth."
        }
      />

      <div
        className={styles.marker}
        style={{ backgroundColor: areaFillColor }}
      />

      <Text variant={"body"} color={"text"}>
        High and Low
      </Text>

      <TooltipBasic
        className={styles.tooltip}
        type={"secondary"}
        text={
          "The High Case represents the Median Case plus one standard deviation (~16% probability of achieving that net worth or higher). The Low Case represents the Median Case minus one standard deviation (~84% chance of achieving that net worth or higher)."
        }
      />
    </div>
  );
};

export default FinancialPlansProjectionGraphLegend;
